import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { NavigationLinkForm } from './NavigationLinkForm/NavigationLinkForm';
import { LinkItemListItem } from './NavigationLinkElement/NavigationLinkElement';
import { NavigationLinkGetType } from 'src/AppState/TopNavigationLinkState/TopNavigationLinkState';
import { ColumnOneOfTwo, MainContent, TwoColumnResponsiveContentReverse } from 'src/domains/layouts/shared/layout/Layout.style';
import { ListContainer } from 'src/domains/layouts/shared/cms/list/List.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const HeaderLinkPanel = observer(() => {
    const { topNavigationLinkState } = useAppStateContext();

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer areLoading={topNavigationLinkState.isLoading}>
                        <Loader isActive={topNavigationLinkState.isLoading} />
                        {topNavigationLinkState.navigationLinksSorted !== null &&
                            topNavigationLinkState.navigationLinksSorted.map(
                                (navigationLink: NavigationLinkGetType | null) => {
                                    return navigationLink !== null ? (
                                        <LinkItemListItem key={navigationLink?.id} navigationLink={navigationLink} />
                                    ) : null;
                                }
                            )}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <NavigationLinkForm />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
